import { render } from "./MetodoPagoList.vue?vue&type=template&id=5224de90&scoped=true"
import script from "./MetodoPagoList.vue?vue&type=script&lang=js"
export * from "./MetodoPagoList.vue?vue&type=script&lang=js"

import "./MetodoPagoList.vue?vue&type=style&index=0&id=5224de90&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5224de90"]])

export default __exports__